var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPopupCallOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#555"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 15.454c-.962 0-1.75.819-1.75 1.819s.788 1.818 1.75 1.818S27 18.273 27 17.273s-.788-1.819-1.75-1.819zM27 22.727c0-1-.788-1.818-1.75-1.818s-1.75.818-1.75 1.818.788 1.819 1.75 1.819S27 23.727 27 22.727zM20 30c.962 0 1.75-.818 1.75-1.818s-.788-1.818-1.75-1.818-1.75.818-1.75 1.818S19.038 30 20 30zm-5.25-16.364c.963 0 1.75-.818 1.75-1.818S15.713 10 14.75 10 13 10.818 13 11.818s.787 1.818 1.75 1.818zM25.25 10c-.962 0-1.75.818-1.75 1.818s.788 1.818 1.75 1.818S27 12.818 27 11.818 26.212 10 25.25 10zm-10.5 14.546c.963 0 1.75-.819 1.75-1.819s-.787-1.818-1.75-1.818-1.75.818-1.75 1.818.787 1.819 1.75 1.819zm0-5.455c.963 0 1.75-.818 1.75-1.818s-.787-1.819-1.75-1.819-1.75.819-1.75 1.819.787 1.818 1.75 1.818zM20 24.545c.962 0 1.75-.818 1.75-1.818S20.962 20.91 20 20.91s-1.75.818-1.75 1.818.788 1.819 1.75 1.819zm0-5.454c.962 0 1.75-.818 1.75-1.818s-.788-1.819-1.75-1.819-1.75.819-1.75 1.819.788 1.818 1.75 1.818zm0-5.455c.962 0 1.75-.818 1.75-1.818S20.962 10 20 10s-1.75.818-1.75 1.818.788 1.818 1.75 1.818z",
    fill: "#fff"
  })));
}

export default SvgObPopupCallOther;